import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../fragments'

const COURSE_TYPES_QUERY = gql`
  query courseTypes($filters: CourseTypeFiltersInput) {
    courseTypes(filters: $filters) {
      results {
        ...MetadataNodeFragment
        isIgnored
        isDefaultFilter
        children {
          ...MetadataNodeFragment
          isIgnored
          isDefaultFilter
          children {
            ...MetadataNodeFragment
            isIgnored
            isDefaultFilter
          }
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default COURSE_TYPES_QUERY
